import React from "react";

/**
 * Button — refined VÉRAULT button. Quiet by default, intentional motion.
 * variants: primary (charcoal), gold (accent), ghost, link
 * size: sm | md | lg
 */
const VARIANTS = {
  primary:
    "bg-[hsl(var(--foreground))] text-[hsl(var(--primary-foreground))] hover:bg-black border border-transparent",
  gold:
    "bg-[hsl(var(--accent-gold))] text-white hover:bg-[hsl(var(--accent-gold))]/90 border border-transparent",
  ghost:
    "bg-transparent text-[hsl(var(--foreground))] hover:bg-[hsl(var(--background-paper))] border border-[rgba(0,0,0,0.08)]",
  quiet:
    "bg-transparent text-[hsl(var(--foreground-secondary))] hover:text-[hsl(var(--foreground))] hover:bg-[hsl(var(--background-paper))] border border-transparent",
  danger:
    "bg-[hsl(var(--accent-terracotta))] text-white hover:bg-[hsl(var(--accent-terracotta))]/90 border border-transparent",
  link:
    "bg-transparent text-[hsl(var(--foreground))] hover:text-[hsl(var(--accent-gold))] border border-transparent p-0 h-auto underline-offset-4 hover:underline",
};

const SIZES = {
  sm: "h-8 px-3 text-[12px]",
  md: "h-10 px-5 text-sm",
  lg: "h-12 px-6 text-[15px]",
};

export const PortalButton = React.forwardRef(function PortalButton(
  {
    as: As = "button",
    variant = "primary",
    size = "md",
    className = "",
    children,
    icon,
    iconAfter,
    ...rest
  },
  ref
) {
  const sizeCls = variant === "link" ? "" : SIZES[size] || SIZES.md;
  return (
    <As
      ref={ref}
      className={`inline-flex items-center justify-center gap-2 rounded-full whitespace-nowrap font-body font-medium tracking-tight transition-all duration-200 ease-[cubic-bezier(0.22,0.61,0.36,1)] disabled:opacity-40 disabled:pointer-events-none ${
        VARIANTS[variant] || VARIANTS.primary
      } ${sizeCls} ${className}`}
      {...rest}
    >
      {icon && <span className="-ml-0.5 flex items-center">{icon}</span>}
      <span>{children}</span>
      {iconAfter && <span className="-mr-0.5 flex items-center">{iconAfter}</span>}
    </As>
  );
});
